import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  DesignState,
  setLastDimensionFilter,
} from "../../../features/designSlice";
import useFilterLogic from "../hooks/useFilterLogic";
import useStepper from "../../../components/stepper/hooks/useStepper";
import Shape from "../../../models/furniture/Shape";

const DimensionFilter = ({ options }: { options: Shape[] }) => {
  const dispatch = useDispatch();

  const { lastDimensionFilter, shapes: selectedShapes } = useSelector(
    (state: { design: DesignState }) => state.design
  );

  const {
    filters: { dimensionsFilters },
    selectedFilters: { selectedDimensionsFilters },
    selectDimensionFilter,
  } = useFilterLogic();

  const { currentStepData } = useStepper();

  useEffect(() => {
    options.forEach((option) => {
      if (
        selectedShapes[currentStepData?.elementOrder.toString()]?.code ===
        option?.code
      ) {
        if (option?.dimension_tags && option?.dimension_tags.length > 0) {
          if (
            lastDimensionFilter &&
            option?.dimension_tags.includes(lastDimensionFilter)
          ) {
            selectDimensionFilter(lastDimensionFilter);
          } else {
            selectDimensionFilter(option?.dimension_tags[0]);
            dispatch(
              setLastDimensionFilter({
                newDimensionFilter: option?.dimension_tags[0],
              })
            );
          }
        }
      }
    });
  }, [dimensionsFilters, options, selectedShapes]);

  const handleSelectDimensionFilter = (dimensionsFilter: string) => {
    selectDimensionFilter(dimensionsFilter);
    dispatch(setLastDimensionFilter({ newDimensionFilter: dimensionsFilter }));
  };

  return (
    <div className="flex h-fit w-fit max-w-full flex-wrap">
      {dimensionsFilters?.map((dimensionsFilter, index) => {
        const isSelected = !!selectedDimensionsFilters.find(
          (filter) => filter === dimensionsFilter
        );
        return (
          <button
            key={index}
            className={` h-6 w-[80px] shrink-0 bg-gray-100 px-3 py-1 text-[11px] text-secondary first:rounded-l last:rounded-r ${
              isSelected && "rounded bg-highlight text-white"
            }`}
            onClick={() => handleSelectDimensionFilter(dimensionsFilter)}
          >
            {dimensionsFilter}
          </button>
        );
      })}
    </div>
  );
};

export default DimensionFilter;
